import { render, staticRenderFns } from "./itemclasificacion.vue?vue&type=template&id=2769c2fc&scoped=true"
import script from "./itemclasificacion.vue?vue&type=script&lang=js"
export * from "./itemclasificacion.vue?vue&type=script&lang=js"
import style0 from "./itemclasificacion.vue?vue&type=style&index=0&id=2769c2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2769c2fc",
  null
  
)

export default component.exports